import './App.css';
import NavBar from './components/AppBar';
import Content from './components/Content';
import './firebase'
// Import the functions you need from the SDKs you need

function App() {
  return (<>
    <NavBar />
    <Content />
    </>
  );
}

export default App;
